// extracted by mini-css-extract-plugin
export default {"result__title":"kdVrAf5evreLYtWnHvCU","no-results":"ew4M7Behksw0W5vpoh9o","no-results-label":"GF8Br1vBP03ypeBaBns3"};